import { useState } from "react";

export default function TabSelector({ tabs, activeTab, setActiveTab }: any) {
  return (
    <div className="w-full  mx-auto mt-6">
      {/* Tab Header */}
      <div className="flex border-b border-gray-50 bg-gray-50 rounded-md pt-1 px-1 mx-10">
        {tabs.map((tab: any) => (
          <button
            key={tab.id}
            className={`flex-1 text-center py-2 font-medium text-sm transition-colors  rounded-md
              ${
                activeTab === tab.id
                  ? "border-b-2 border-blue-500 text-blue-600 bg-white"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
